import React from 'react';

import {SvgProps} from '../../helpers/type';

const TiltedArrow = ({className}: SvgProps): JSX.Element => {
    return (
        <svg
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect
                x="0.712988"
                y="0.7125"
                width="44.175"
                height="44.175"
                rx="9.42083"
                fill="#EDFCF2"
                fillOpacity="0.5"
            />
            <path
                d="M20.3005 15.3V17.3H26.8905L15.3005 28.89L16.7105 30.3L28.3005 18.71V25.3H30.3005V15.3H20.3005Z"
                fill="#5D847F"
            />
            <rect
                x="0.712988"
                y="0.7125"
                width="44.175"
                height="44.175"
                rx="9.42083"
                stroke="#E8EDEC"
                strokeWidth="1.425"
            />
        </svg>
    );
};

export default TiltedArrow;
